export default {
  list: [
    { title: 'شنبه', value: 'SAT' },
    { title: 'یکشنبه', value: 'SUN' },
    { title: 'دوشنبه', value: 'MON' },
    { title: 'سه شنبه', value: 'TUE' },
    { title: 'چهارشنبه', value: 'WED' },
    { title: 'پنج شنبه', value: 'THU' },
    { title: 'جمعه', value: 'FRI' }
  ],
  values: {
    SAT: 'SAT',
    SUN: 'SUN',
    MON: 'MON',
    TUE: 'TUE',
    WED: 'WED',
    THU: 'THU',
    FIR: 'FRI'
  }
};
